import {
  cancelOrder,
  getOrders,
} from '@/api/order';
import {
  getCart,
} from '@/utils/helper';

import {
  CANCEL_ORDER,
  CANCELING_ORDER,
  CLEAR_ORDERS,
  CLEAR_ORDERS_DONE,
  GET_ORDERS,
  GET_ORDERS_DONE,
  GETTING_ORDERS,
  SEND_ORDER,
  SENDING_ORDER,
} from './constants';

export default {
  async [CANCEL_ORDER]({ commit }, uuid) {
    commit(CANCELING_ORDER, true);
    try {
      const res = await cancelOrder(uuid);
      commit(CANCELING_ORDER, false);
      return Promise.resolve(res);
    } catch (error) {
      commit(CANCELING_ORDER, false);
      return Promise.reject(error);
    }
  },
  async [GET_ORDERS]({ commit }, payload = {}) {
    commit(GETTING_ORDERS, true);
    try {
      const { data = [] } = await getOrders(payload);
      commit(GET_ORDERS_DONE, data);
      commit(GETTING_ORDERS, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_ORDERS_DONE, {});
      commit(GETTING_ORDERS, false);
      return Promise.reject(error);
    }
  },
  async [SEND_ORDER]({ commit }, data = {}) {
    commit(SENDING_ORDER, true);
    const { items = [], menu_id: mid } = getCart();
    try {
      const {
        cb,
        ...props
      } = data;
      if (!cb) {
        throw new Error('Callback function is required');
      }
      const datum = {
        member_order_items: items.map(({
          count,
          index,
          note,
          options,
        }) => ({
          entree_index: index,
          note,
          options,
          quantity: count,
        })),
        ...props,
      };
      await cb(mid, datum);
      commit(SENDING_ORDER, false);
      return Promise.resolve();
    } catch (error) {
      commit(SENDING_ORDER, false);
      return Promise.reject(error);
    }
  },
  [CLEAR_ORDERS]({ commit }) {
    commit(CLEAR_ORDERS_DONE);
  },
};
